import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, Button, Spinner } from 'react-bootstrap';
import styled from 'styled-components';
import { useHistory } from "react-router-dom";
import FaMobileAlt from '@material-ui/icons/PhoneIphone';
import FaDesktop from '@material-ui/icons/DesktopWindows';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { obtenerDatosUsuarios } from "../../services/firebase/perfilesUsuarios";
import PeopleIcon from "@material-ui/icons/People";

const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  background: #f0f2f5;
  overflow: hidden;
`;

const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background: white;
  border-bottom: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  z-index: 10;
`;

const SimulatorArea = styled.div`
  flex: 1;
  padding: 40px;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #f0f2f5;
`;

const DeviceContainer = styled.div`
  background: white;
  width: ${props => props.viewMode === 'mobile' ? '375px' : '100%'};
  max-width: ${props => props.viewMode === 'mobile' ? '375px' : '1200px'};
  min-height: ${props => props.viewMode === 'mobile' ? '667px' : '800px'};
  border-radius: ${props => props.viewMode === 'mobile' ? '40px' : '15px'};
  border: ${props => props.viewMode === 'mobile' ? '12px solid #1a1a1a' : '1px solid #dee2e6'};
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
`;

const PreviewContent = ({ data, specialists = [] }) => {
  const hasLogo = data.logoUrl && !data.logoUrl.toLowerCase().includes('sysdent');
  const filteredSpecialists = specialists.filter(s => 
    ['ODONTOLOGO', 'ODONTOLOGO_ADM'].includes(s.perfil) || s.cargo?.toUpperCase().includes('DOCTOR')
  );

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", color: '#0C234C' }}>
      {/* Hero */}
      <div style={{ 
        background: '#0C1B33', 
        padding: '60px 20px', 
        textAlign: 'center', 
        color: 'white',
        position: 'relative'
      }}>
        <div style={{ marginBottom: '30px' }}>
          {hasLogo ? (
            <img src={data.logoUrl} alt="Logo" style={{ maxHeight: '80px', borderRadius: '12px' }} />
          ) : (
            <div style={{ background: 'linear-gradient(135deg, #0C8DE3, #67D2DC)', width: '60px', height: '60px', borderRadius: '15px', margin: '0 auto' }}></div>
          )}
        </div>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '15px', letterSpacing: '-0.02em' }}>{data.razonSocial || 'CENTRO DENTAL'}</h1>
        <p style={{ fontSize: '1.2rem', color: '#67D2DC', fontStyle: 'italic', maxWidth: '600px', margin: '0 auto 30px' }}>
          {data.descripcion ? `"${data.descripcion}"` : '"Excelencia en el cuidado de tu sonrisa."'}
        </p>
        <button style={{ 
          background: '#0C8DE3', 
          border: 'none', 
          color: 'white', 
          padding: '12px 35px', 
          borderRadius: '50px', 
          fontWeight: 'bold',
          fontSize: '1rem',
          boxShadow: '0 4px 15px rgba(12, 141, 227, 0.4)'
        }}>
          Reservar Cita
        </button>
      </div>

      {/* About Us section */}
      <div style={{ padding: '60px 40px', textAlign: 'center', background: 'white' }}>
        <span style={{ color: '#0C8DE3', fontWeight: 'bold', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '2px' }}>Nuestra Clínica</span>
        <h2 style={{ fontSize: '2rem', marginTop: '10px', fontWeight: 'bold' }}>Bienvenido</h2>
        <p style={{ color: '#64748b', fontSize: '1.1rem', maxWidth: '600px', margin: '20px auto 0', lineHeight: '1.6' }}>
          {data.descripcion ? "Estamos felices de recibirte y brindarte la mejor atención." : "Estamos listos para atenderte con la mejor tecnología y calidez humana."}
        </p>
      </div>

      {/* Specialists Preview */}
      <div style={{ padding: '60px 40px', background: '#f8fafc' }}>
        <h3 style={{ fontSize: '1.8rem', textAlign: 'center', marginBottom: '40px', fontWeight: 'bold' }}>Nuestros Especialistas</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
          {filteredSpecialists.length > 0 ? filteredSpecialists.map(esp => (
            <div key={esp.id} style={{ background: 'white', borderRadius: '25px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}>
              {esp.foto ? (
                  <img src={esp.foto} alt={esp.nombres} style={{ width: '100%', height: '220px', objectFit: 'cover' }} />
              ) : (
                  <div style={{ height: '220px', background: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PeopleIcon style={{ fontSize: '60px', color: '#cbd5e1' }} />
                  </div>
              )}
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>{esp.nombres}</div>
                <div style={{ color: '#0C8DE3', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase' }}>{esp.especialidad || esp.perfil}</div>
                <p style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '10px', fontStyle: 'italic' }} className="line-clamp-2">
                    {esp.biografia ? `"${esp.biografia}"` : 'Especialista comprometido con tu salud.'}
                </p>
              </div>
            </div>
          )) : (
              <div className="text-center w-100 p-5 text-muted">Aún no se han configurado especialistas.</div>
          )}
        </div>
      </div>

      {/* Location Area */}
      <div style={{ padding: '60px 40px', background: 'white' }}>
        <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px' }}>Ubícanos</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: '1.1rem', color: '#475569', marginBottom: '20px' }}>
              <i className="fas fa-map-marker-alt text-primary me-2"></i>
              {data.direccion || 'Dirección de la clínica no especificada'}
            </p>
            {data.googleBusiness && (
                <div 
                    style={{ background: '#0C8DE3', color: 'white', padding: '15px 25px', borderRadius: '12px', display: 'inline-block', fontWeight: 'bold', cursor: 'pointer' }}
                    onClick={() => window.open(data.googleBusiness, '_blank')}
                >
                  Cómo llegar
                </div>
            )}
          </div>
          <div style={{ background: '#f1f5f9', height: '250px', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px dashed #cbd5e1' }}>
            <span style={{ color: '#94a3b8' }}>Mapa de Ubicación</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const LandingPreview = () => {
  const empresa = useSelector(state => state.empresa);
  const sesion = useSelector(state => state.sesion);
  const history = useHistory();
  const [viewMode, setViewMode] = useState('desktop');
  const [specialists, setSpecialists] = useState([]);

  useEffect(() => {
    const fetchSpecialists = async () => {
      if (empresa.id) {
        const data = await obtenerDatosUsuarios(empresa.id);
        setSpecialists(data);
      }
    };
    fetchSpecialists();
  }, [empresa.id]);

  if (sesion.loading) return <Container className="p-5 text-center"><Spinner animation="border" /></Container>;

  return (
    <PreviewWrapper>
      <Toolbar>
        <div className="d-flex align-items-center gap-3">
          <Button variant="light" onClick={() => history.goBack()} className="d-flex align-items-center gap-2" style={{ borderRadius: '10px' }}>
            <ArrowBackIcon /> Regresar
          </Button>
          <div className="vr mx-2"></div>
          <div>
            <h5 className="mb-0 fw-bold">Previsualización de Landing Page</h5>
            <small className="text-muted">{empresa.razonSocial}</small>
          </div>
        </div>

        <div className="d-flex gap-2 bg-light p-1" style={{ borderRadius: '12px' }}>
          <Button 
            variant={viewMode === 'desktop' ? 'white' : 'light'} 
            className={`shadow-sm ${viewMode === 'desktop' ? 'fw-bold' : ''}`}
            onClick={() => setViewMode('desktop')}
            size="sm"
            style={{ borderRadius: '10px', border: viewMode === 'desktop' ? '1px solid #dee2e6' : 'none' }}
          >
            <FaDesktop className="me-2" /> Escritorio
          </Button>
          <Button 
            variant={viewMode === 'mobile' ? 'white' : 'light'} 
            className={`shadow-sm ${viewMode === 'mobile' ? 'fw-bold' : ''}`}
            onClick={() => setViewMode('mobile')}
            size="sm"
            style={{ borderRadius: '10px', border: viewMode === 'mobile' ? '1px solid #dee2e6' : 'none' }}
          >
            <FaMobileAlt className="me-2" /> Móvil
          </Button>
        </div>

        <div>
           <Button variant="primary" className="fw-bold px-4 rounded-pill" onClick={() => window.open(empresa.slug ? `https://pac.sysdent.net/${empresa.slug}` : '', '_blank')}>
             Ver Pública
           </Button>
        </div>
      </Toolbar>

      <SimulatorArea>
        <DeviceContainer viewMode={viewMode}>
          <PreviewContent data={empresa} specialists={specialists} />
        </DeviceContainer>
      </SimulatorArea>
    </PreviewWrapper>
  );
};

export default LandingPreview;
